import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
    display: inline-flex;
`;
Wrapper.displayName = 'Wrapper';
